import React from "react";
import ProfileContainer from "../../components/Account/Profile/ProfileContainer";

type Props = {};

const Profile = (props: Props) => {
  return (
    <div className="page">
      <ProfileContainer />
    </div>
  );
};

export default Profile;
